<template>
<div>
    <h1 class="sr-only">Pauline Fuchs - A propos</h1>
    <div v-if="content">
    <AboutSection v-for="(section,index) in content.sections" :key="index" :about="section" :index="index"/>
    <AboutCourse :course="content.parcours"/>
    </div>
    <ElementsLineStars/>
    <FormContact/>
</div>
</template>
<script setup lang='ts'>

import type { SiteOptions } from '~/types/options'

const { getContentAcf } = useWordpressApi()

const { data: content, pending } = await useAsyncData<SiteOptions | null>(
  'acf-options',
  () => getContentAcf()
)


useSeoMeta({
    title: `Pauline Fuchs - A propos`,
    ogTitle:  `Pauline Fuchs - A propos`,
    description: "Directrice artistique, illustratrice et motion designer freelance à Lille. Je crée des visuels animés pour documentaires, musées et institutions culturelles.",
    ogDescription: "Moi c'est Pauline. Je suis directrice artistique, illustratrice et motion designer freelance depuis 4 ans. Aujourd'hui installée à Lille, bercée par la pluie et la bière, je crée des illustrations et visuels animés pour des réalisateur·ices de documentaires, des musées et des institutions culturelles.",
    ogImage: '/hero-photo.png',
})
</script>